import {IBookingSearchResultRecordViewModel} from "./booking-search-result-record.view-model.interface";
import {IServiceFactory} from "../service-factory.interface";
import {IBookingSearchResultRecord} from "../airline-webapi/responses/booking-search.response";
import {NullableStation} from "../stations/station.service.interface";
import {BookingStatusEnum, getBookingStatusName} from "../dot-rez-api/data-contracts/enums/booking-status.enum";
import {Check} from "../../types/type-checking";

export class BookingSearchResultRecordModel implements IBookingSearchResultRecordViewModel {
    constructor(private readonly services: IServiceFactory,
                private readonly dotRezResultItem: IBookingSearchResultRecord) {
    }

    get uniqueKey(): string {
        return `${this.pnr}_${this.agent}_${this.flightDate}_${this.flightNumber}_${this.bookingStatusName}_${this.passenger}_${this.origin?.stationCode}_${this.destination?.stationCode}`;
    }

    get canBeModified(): boolean {
        return this.dotRezResultItem.editable && !Check.isEmpty(this.flightNumber);
    }

    get pnr(): string {
        return this.dotRezResultItem.recordLocator;
    }

    get origin(): NullableStation {
        return this.services.stations.tryGetStation(this.dotRezResultItem.origin);
    }

    get destination(): NullableStation {
        return this.services.stations.tryGetStation(this.dotRezResultItem.destination);
    }

    get passenger(): string {
        if(!this.dotRezResultItem.name) {
            return "";
        }

        return `${this.dotRezResultItem.name.first} ${this.dotRezResultItem.name.last}`;
    }

    get flightNumber(): string {
        return this.dotRezResultItem.flightNumber ?? "";
    }

    get flightDate(): string {
        if(this.flightNumber && this.dotRezResultItem.flightDate) {
            return this.dotRezResultItem.flightDate;
        }
        return "";
    }

    get flightDepartureDate(): string {
        if(this.flightDate) {
            return this.services.time.shortDateInCurrentLocale(this.flightDate)
        }
        return "";
    }
    get flightDepartureTime(): string {
        if(this.flightDate) {
            return this.services.time.formatHHmm(this.flightDate)
        }
        return "";
    }

    get bookingStatus(): BookingStatusEnum {
        return this.dotRezResultItem.bookingStatus;
    }

    get bookingStatusName(): string {
        return getBookingStatusName(this.dotRezResultItem.bookingStatus);
    }

    get agent(): string {
        return this.dotRezResultItem.sourceAgentCode;
    }

    async retrieveBooking(): Promise<void> {
        if(!this.canBeModified) {
            return;
        }
        await this.services.booking.startManageMyBookingByLastName({
            recordLocator: this.pnr,
            lastName: this.dotRezResultItem.name.last ?? ""
        }, null)
    }

}